import { mockAuditEntries } from "@/app/library/data_sources/mock";
import { Button } from "@/core/ui/atoms";
import { DataTable, EmptyState, PageHeader } from "@/core/ui/molecules";

export function AuditLogPage() {
  return (
    <>
      <PageHeader
        actions={<Button>Export CSV</Button>}
        breadcrumb={["Governance", "Audit Log"]}
        subtitle="Structured activity from Super Admin actions."
        title="Audit Log"
      />
      {mockAuditEntries.length ? (
        <DataTable
          columns={[
            {
              header: "When",
              key: "when",
              render: (entry) => entry.when,
            },
            {
              header: "User",
              key: "user",
              render: (entry) => entry.user,
            },
            {
              header: "Action",
              key: "action",
              render: (entry) => (
                <span className="font-mono text-xs">{entry.action}</span>
              ),
            },
            {
              header: "Target",
              key: "target",
              render: (entry) => entry.target,
            },
            {
              header: "Reason",
              key: "reason",
              render: (entry) => entry.reason,
            },
          ]}
          rowKey={(entry) => `${entry.when}-${entry.action}-${entry.target}`}
          rows={mockAuditEntries}
        />
      ) : (
        <section className="rounded-panel border border-border bg-surface">
          <EmptyState
            description="Create or modify something to generate audit records."
            title="No audit entries yet"
          />
        </section>
      )}
    </>
  );
}
